import Vue from "vue";
import VueRouter from "vue-router";

// 引入nprogress #一款页面加载时进度条
import NProgress from "nprogress";
import "nprogress/nprogress.css";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/recommend",
  },
  {
    // 推荐页面
    path: "/recommend",
    name: "recommend",
    component: () => import("@/views/Recommend/Recommend"),
    meta: { title: "农业云门户" },
  },
  {
    path: "/toplist",
    name: "toplist",
    component: () => import("@/views/Toplist/Toplist"),
    meta: { title: "企业风采" },
  },
  {
    path: "/playlist",
    name: "playlist",
    component: () => import("@/views/Playlist/Playlist"),
    meta: { title: "农业新闻" },
  },
  {
    path: "/searchIndex",
    name: "searchIndex",
    component: () => import("@/views/Playlist/searchIndex"),
    meta: { title: "搜索" },
  },
  {
    path: "/playlistDetail",
    name: "playlistDetail",
    component: () => import("@/views/Playlist/playlistDetail"),
    meta: { title: "绿色动态详情" },
  },
    {
    path: "/djradio",
    name: "djradio",
    component: () => import("@/views/Djradio/Djradio"),
    meta: { title: "科技推广" },

  },

  {
    path: "/qualitysafe",
    name: "qualitysafe",
    component: () => import("@/views/Qualitysafe/qualitysafe"),
    meta: { title: "质量安全" },

  },

  {
    path: "/singer",
    name: "singer",
    component: () => import("@/views/Singer/Singer"),
    meta: { title: "政策法规" },
  },
  {
    path: "/singerDetail",
    name: "singerDetail",
    component: () => import("@/views/Singer/singerDetail"),
    meta: { title: "政策法规详情" },
  }
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    // 跳转路由时页面滚到顶部
    return { x: 0, y: 0 };
  },
});

// 路由跳转前钩子函数中 - 执行进度条开始加载
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.query.title) {
    document.title = to.query.title;
  }
  NProgress.start();
  next();
});

// 路由跳转后钩子函数中 - 执行进度条加载结束
router.afterEach(() => {
  NProgress.done();
});

export default router;
